import { z } from 'zod';
import { nlwTiers } from '~/util/types/nlw';
import { allTags, Tag } from '~/util/types/tags';

const allTagsSet = new Set(allTags);

const rangeSchema = z.object({
    min: z.number().optional(),
    max: z.number().optional(),
});

export const rangeProperties = [
    'position',
    'edel_enjoyment',
    'gddl_tier',
] as const;

export type rangeProperty = (typeof rangeProperties)[number];

const rangesSchema = z.record(z.enum(rangeProperties), rangeSchema);
const defaultRanges = rangesSchema.parse({
    position: {},
    edel_enjoyment: {},
    gddl_tier: {},
});

const tagsSchema = z.preprocess(
    (tags) => {
        if (typeof tags !== 'object' || tags === null) return {};
        const out: Partial<Record<Tag, boolean>> = {};
        for (const [key, value] of Object.entries(tags)) {
            if (allTagsSet.has(key as Tag) && typeof value === 'boolean') {
                out[key as Tag] = value;
            }
        }
        return out;
    },
    z.partialRecord(z.enum(allTags), z.boolean()).default({}).catch({}),
);

const defaultTags = tagsSchema.parse({});

export const filtersParamsSchema = z.object({
    ranges: rangesSchema.default(defaultRanges).catch(defaultRanges),
    tags: tagsSchema.default(defaultTags).catch(defaultTags),
    tiers: z.array(z.enum(nlwTiers)).default([]).catch([]),
    completed_by_user: z
        .enum(['all', 'completed', 'uncompleted'])
        .default('all')
        .catch('all'),
    favorited_by_user: z.boolean().default(false).catch(false),
});

const defaultFilters = filtersParamsSchema.parse({});

export type filtersParamsType = z.infer<typeof filtersParamsSchema>;

export const listParamsSchema = z.object({
    search: z.string().max(100).default('').catch(''),
    sort: z
        .enum(['rank', 'enjoyment', 'records', 'creation_date'])
        .default('rank')
        .catch('rank'),
    tiers_mode: z.boolean().default(false).catch(false),
    reverse: z.boolean().default(false).catch(false),
    filters: filtersParamsSchema.default(defaultFilters).catch(defaultFilters),
    time_machine: z.string().optional(),
});

export type listParamsType = z.infer<typeof listParamsSchema>;

export const defaultListParams = listParamsSchema.parse({});
